var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 2.5H4.16699C2.98848 2.5 2.39923 2.5 2.03311 2.8435C1.66699 3.187 1.66699 3.73985 1.66699 4.84555V5.4204C1.66699 6.28527 1.66699 6.7177 1.88333 7.07618C2.09966 7.43466 2.49489 7.65715 3.28534 8.10212L5.71286 9.46865C6.24321 9.7672 6.50838 9.91648 6.69825 10.0813C7.09365 10.4246 7.33706 10.8279 7.44736 11.3226C7.50032 11.5602 7.50032 11.8382 7.50032 12.3941L7.50033 14.6187C7.50033 15.3766 7.50033 15.7556 7.71026 16.0511C7.9202 16.3465 8.29306 16.4923 9.03879 16.7838C10.6043 17.3958 11.3871 17.7018 11.9437 17.3537C12.5003 17.0055 12.5003 16.2099 12.5003 14.6187V12.3941C12.5003 11.8382 12.5003 11.5602 12.5533 11.3226C12.6636 10.8279 12.907 10.4246 13.3024 10.0813C13.4923 9.91648 13.7574 9.7672 14.2878 9.46865L16.7153 8.10212C17.5058 7.65715 17.901 7.43466 18.1173 7.07618C18.3337 6.7177 18.3337 6.28527 18.3337 5.4204V4.84555C18.3337 3.73985 18.3337 3.187 17.9675 2.8435C17.6014 2.5 17.0122 2.5 15.8337 2.5Z",
    fill: "#DC143C",
    stroke: "#DC143C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d3267780d0c024a632e754478a786c8d.svg";
export { ForwardRef as ReactComponent };